<template>
  <b-container fluid>
    <b-row>
      <b-col lg="12">
        <iq-card>
          <template v-slot:headerTitle></template>
          <template v-slot:headerAction></template>
          <template v-slot:body>
            <b-row>
              <b-col cols="6">
                <h3>{{ $t("public.components.ipros.iprosForm.titleActive") }}</h3>
                <b-form-group label-for="active">
                  <template slot="label">{{ $t("public.components.ipros.iprosForm.active") }}:</template>
                  <b-form-checkbox id="active" v-model="active" :disabled="disabled" size="lg" switch></b-form-checkbox>
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <h3>{{ $t("public.components.ipros.iprosForm.titleGeneral") }}</h3>
                <b-form-group label-for="my">
                  <template slot="label">{{ $t("public.components.ipros.iprosForm.my") }}:</template>
                  <ckeditor v-model="my" :config="configCK" :disabled="disabled" type="classic"></ckeditor>
                </b-form-group>
                <b-form-group label-for="speciality">
                  <template slot="label">{{ $t("public.components.ipros.iprosForm.speciality") }}:
                  </template>
                  <ckeditor v-model="speciality" :config="configCK" :disabled="disabled" type="classic"></ckeditor>
                </b-form-group>
                <b-form-group label-for="videos">
                  <template slot="label">{{ $t("public.components.ipros.iprosForm.videos") }}:</template>
                  <ckeditor v-model="videos" :config="configCK" :disabled="disabled" type="classic"></ckeditor>
                </b-form-group>
                <b-form-group label-for="videos">
                  <template slot="label">{{ $t("public.components.ipros.iprosForm.professionalLanguage") }}:
                  </template>
                  <b-form-select v-model="professionalLanguage" :options="languagesSelect" :select-size="4"
                    multiple></b-form-select>
                </b-form-group>
                <div v-if="urlIpros">
                  <span class="mr-2">{{ $t("public.components.ipros.iprosForm.url") }}:</span>
                  <a :href="urlIpros">{{ urlIpros }}</a>
                </div>
              </b-col>
            </b-row>
          </template>
        </iq-card>
      </b-col>
    </b-row>
    <notifications group="notificacions" />
  </b-container>
</template>
<script>
import LanguageISO639 from "../../json/LanguageISO639-1";

import { xray } from "../../config/pluginInit";

import iprosService from "../../services/ipros";
import utilsService from "../../services/utils";

export default {
  name: "IprosForm",
  props: {
    professionalId: {},
  },
  mounted() {
    xray.index();
    this.createUrlIpros();
    this.get();
  },
  components: {},
  data() {
    return {
      urlIpros: "",
      disabled: false,
      //Data validate form
      isFirstRun: true,
      isValidate: false,
      //Data form
      active: true,
      my: "",
      speciality: "",
      videos: "",
      professionalLanguage: [],

      //--
      //Config
      configCK: {
        fillEmptyBlocks: false,
        basicEntities: false,
        entities: false,
        entities_greek: false,
        entities_latin: false,
        entities_additional: "",
        language: "es",
      },

      languagesSelect: LanguageISO639,
    };
  },
  methods: {
    async createUrlIpros() {
      this.urlIpros =
        process.env.VUE_APP_BASE_URL_WEBAPP +
        "public/ipros?professionalId=" +
        this.professionalId;
    },
    async get() {
      let self = this;
      this.$awn.asyncBlock(
        iprosService.get(this.professionalId),
        (response) => {
          if (response) {
            self.id = response.data.id;
            self.active = response.data.active;
            self.my = response.data.my;
            self.speciality = response.data.speciality;
            self.videos = response.data.videos;
            self.professionalLanguage = response.data.professionalLanguage;
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "iprosService.get",
            module: "component-ipros-iprosform",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({ professionalId: this.professionalId }),
          });
        },
        " "
      );
    },
    saveForm() {
      let data = {
        id: this.id,
        professionalId: this.professionalId,
        active: this.active,
        my: this.my,
        speciality: this.speciality,
        videos: this.videos,
        professionalLanguage: this.professionalLanguage,
      };
      this.$awn.asyncBlock(
        iprosService.save(this.professionalId, data),
        (response) => {
          if (response) {
            this.$notify({
              group: "notificacions",
              title: this.$i18n.t(
                "public.components.ipros.iprosForm.notifications.title"
              ),
              text: this.$i18n.t(
                "public.components.ipros.iprosForm.notifications.desc"
              ),
              type: "success",
            });
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "iprosService.save",
            module: "component-ipros-iprosform",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({ professionalId: this.professionalId, data: data }),
          });
        },
        " "
      );
    },
  },
  computed: {},
};
</script>
